import { render, staticRenderFns } from "./orderReceiving.vue?vue&type=template&id=e24d8d70&scoped=true&"
import script from "./orderReceiving.vue?vue&type=script&lang=js&"
export * from "./orderReceiving.vue?vue&type=script&lang=js&"
import style0 from "./orderReceiving.vue?vue&type=style&index=0&id=e24d8d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24d8d70",
  null
  
)

export default component.exports